import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const EditLoanStep = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const fetchStep = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getSingleLoanStep/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        setTitle(res.data.step.title);
        if (res.data.step.image) {
          setPreview(`${COMMON_API}/ImgUploads/${res.data.step.image}`);
        }
      }
    } catch (err) {
      console.error("Error fetching step:", err);
    }
  };

  useEffect(() => {
    fetchStep();
  }, [id]);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    if (selected) setPreview(URL.createObjectURL(selected));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("title", title);
      if (file) fd.append("image", file);

      const res = await axios.put(`${COMMON_API}/loan/editLoanStep/${id}`, fd, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        alert("Step updated successfully!");
        navigate(`/loan-step`);
      }
    } catch (err) {
      console.error("Error updating step:", err);
      alert("Failed to update step.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-4">Edit Loan Step</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <div>
            <label className="block text-sm font-semibold">Image</label>
            {preview && <img src={preview} alt="Preview" className="w-48 h-32 rounded mb-2" />}
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </div>
          <button type="submit" className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">
            Update Step
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditLoanStep;
